// Ajoutez ceci au début de votre app.js
window.onerror = function(message, source, lineno, colno, error) {
    console.error('=== ERREUR DÉTAILLÉE ===');
    console.error('Message:', message);
    console.error('Fichier:', source);
    console.error('Ligne:', lineno);
    console.error('Colonne:', colno);
    console.error('Stack complet:', error?.stack);
    return false;
};

// Capture les promesses non gérées
window.addEventListener('unhandledrejection', function(event) {
    console.error('=== PROMESSE NON GÉRÉE ===');
    console.error('Raison:', event.reason);
    console.error('Stack:', event.reason?.stack);
});

import './bootstrap';
import { createApp } from 'vue';

// Importez les composants
import ReclamationForm from './components/ReclamationForm.vue';
import ReclamationFormAr from './components/ReclamationFormAr.vue';
import Dashboard from './components/Dashboard.vue';
import DashboardNavbar from './components/DashboardNavbar.vue';
import DashboardSidebar from './components/DashboardSidebar.vue';
import DashboardContent from './components/DashboardContent.vue';

import permissionManager from '../utils/permissions.js';

const app = createApp({});


app.mixin({
    methods: {
        $can(permission) {
            return permissionManager.can(permission);
        },
        $canAny(permissions) {
            return permissionManager.canAny(permissions);
        },
        $hasRole(roleName) {
            return permissionManager.hasRole(roleName);
        }
    }
});

// Enregistrez les composants globalement
app.component('reclamation-form', ReclamationForm);
app.component('reclamation-form-ar', ReclamationFormAr);
app.component('dashboard', Dashboard);
app.component('dashboard-navbar', DashboardNavbar);
app.component('dashboard-sidebar', DashboardSidebar);
app.component('dashboard-content', DashboardContent);

// Charger les permissions au démarrage
permissionManager.loadPermissions();

app.mount('#app');